import { render, staticRenderFns } from "./PaymentspayEdit.vue?vue&type=template&id=1550182d"
import script from "./PaymentspayEdit.vue?vue&type=script&lang=js"
export * from "./PaymentspayEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports